import { moduleDashboardQuery, type ModuleDashboard } from './moduleDashboard'

/**
 * Tabloul de bord al modulului Inventoree - `GET /api/v2/inventoree/board`.
 *
 * NU `/inventoree/dashboard`: acela e capatul tabloului AmCharts VECHI
 * (`api/inventoreeDashboard.ts`), lasat pe 6 septembrie 2026 dar inca pe
 * ramura. Ce se citeste aici e tabloul de MODUL, cel pe care il vede omul azi
 * cand apasa "Dashboard" in bara Inventoree.
 *
 * Forma raspunsului e cea a oricarui tablou de modul
 * (`api/moduleDashboard.ts`, pereche cu `App\Dashboard\ModuleBoard`).
 */
export type InventoreeBoard = ModuleDashboard

/** Perspectiva, fereastra si clasa de active calatoresc in adresa, ca in portal. */
export function inventoreeBoardQuery(search: string) {
  return moduleDashboardQuery('inventoree', '/inventoree/board', search)
}
